<template>
  <el-row :gutter="20">
    <custom-select
      v-model="suajeTipo"
      label="Tipo de suaje"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar tipo de suaje',
        filterable: true,
        options: suajeTipos,
      }"
    />
    <custom-select
      v-model="forma"
      label="Forma"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar forma',
        filterable: true,
        options: formaList,
      }"
    />
    <custom-select
      v-model="cilindroTipo"
      label="Tipo cilindro"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar tipo de cilindro',
        filterable: true,
        options: cilindroTipoList,
      }"
    />
    <custom-select
      v-model="familiaMaterial"
      label="Familia item"
      :spanColumn="4"
      :settings="{
        placeholder: 'Seleccionar familia',
        filterable: true,
        clearable: true,
        options: materiaPrimaFamilias,
        multiple: true,
      }"
      @click:clearable="handleClearable"
    />
  </el-row>
</template>

<script setup>
import {
  onMounted,
  computed,
  reactive,
  watch,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useSuajeTipoStore } from '@/stores/suaje_tipo/suaje_tipo_store.js';
import { useFormaStore } from '@/stores/forma/forma_store.js';
import { useCilindroTipoStore } from '@/stores/cilindro-tipo/cilindro-tipo.js';
import { useMateriaPrimaFamiliaStore } from '@/stores/materia_prima_familia/materia_prima_familia_store.js';
import CustomSelect from '@/shared/components/custom_select.vue';

const suajeTipoStore = useSuajeTipoStore();
const { suajeTipos } = storeToRefs(suajeTipoStore);

const formaStore = useFormaStore();
const { formaList } = storeToRefs(formaStore);

const cilindroTipoStore = useCilindroTipoStore();
const { cilindroTipoList } = storeToRefs(cilindroTipoStore);

const materiaPrimaFamiliaStore = useMateriaPrimaFamiliaStore();
const { materiaPrimaFamilias } = storeToRefs(materiaPrimaFamiliaStore);

const props = defineProps({
  params: { type: Object, required: true },
});

const emits = defineEmits(['disabled-button', 'update:modelValue']);

const suajeTipo = computed({
  get() {
    return suajeTipos.value.find((mt) => mt.Codigo === props.params.CodigoSuajeTipo);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoSuajeTipo' });
    checkMandatoryProperties();
  },
});

const forma = computed({
  get() {
    return formaList.value.find((mt) => mt.Codigo === props.params.CodigoForma);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoForma' });
    checkMandatoryProperties();
  },
});

const cilindroTipo = computed({
  get() {
    return cilindroTipoList.value.find((mt) => mt.Codigo === props.params.CodigoTipoCilindro);
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoTipoCilindro' });
    checkMandatoryProperties();
  },
});

const familiaMaterial = computed({
  get() {
    return materiaPrimaFamilias.value.filter(
      (mt) => props.params.CodigoFamilia && props.params.CodigoFamilia.includes(mt.Codigo),
    );
  },
  set(value) {
    emits('update:modelValue', { value, property: 'CodigoFamilia' });
  },
});

const checkMandatoryProperties = () => {
  const { CodigoSuajeTipo, CodigoForma, CodigoTipoCilindro } = props.params;
  if (CodigoSuajeTipo > 0 && CodigoForma > 0 && CodigoTipoCilindro > 0) {
    emits('disabled-button', false);
  } else {
    emits('disabled-button', true);
  }
};

const handleClearable = () => {
  emits('update:modelValue', { value: null, property: 'CodigoFamilia' });
};

onMounted(async () => {
  checkMandatoryProperties();
  suajeTipoStore.emptyList();
  await suajeTipoStore.findAllSuajeTipoHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
  formaStore.emptyList();
  await formaStore.findAllFormaHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
  cilindroTipoStore.emptyList();
  await cilindroTipoStore.findAllCilindroTipoHTTP({ page: 0, sortBy: 'Descripcion', sort: 'Asc' });
});
</script>
